import { render, staticRenderFns } from "./SessionResultRanking.vue?vue&type=template&id=4920a6a0&scoped=true&"
import script from "./SessionResultRanking.vue?vue&type=script&lang=js&"
export * from "./SessionResultRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920a6a0",
  null
  
)

export default component.exports